import { documentsScopesEnabled } from '../extensions/bundled/documents/documentsFlags';

/**
 * The Documents workspace a document scope belongs to — the sidebar
 * switcher's key: `personal` | `personal/<scopeId>` | `device` | `team:<id>`.
 * With the `documents.scopes` flag off every personal document is in the one
 * Personal tree, whatever workspace another device gave it. Pure (reads the
 * flag), shared by tabsStore and documentTabWorkspaces.
 */
export function docWorkspaceKey(scope) {
  if (scope?.type === 'team' && scope.teamId != null) return `team:${scope.teamId}`;
  if (scope?.type === 'device') return 'device';
  return scope?.scopeId && documentsScopesEnabled() ? `personal/${scope.scopeId}` : 'personal';
}

/** A switcher key as the tab strip groups it (flag off: `personal/<id>` is Personal). */
export function normalizeWorkspaceKey(key) {
  if (!key) return 'personal';
  if (key.startsWith('personal/') && !documentsScopesEnabled()) return 'personal';
  return key;
}
